<template>
  <gj-table
    v-bind="$attrs"
    v-on="$listeners"
    :columns="customData"
    :data="tableData"
    :index="false"
    class="listing-table"
    :scroll-y="{mode: 'wheel', oSize:14, gt: 40 }"
    :show-header-overflow="true"
  >
    <template v-slot:asin="{ row }">
      <el-row>
        <gj-link :href="row.asinUrl" target="_blank">{{ row.asin | defaultShow }}</gj-link>
        <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin" />
      </el-row>
    </template>
    <template v-slot:title="{ row }">
      <template v-if="row.isVariant">-</template>
      <template v-else>
        <div class="hover-class flex">
          <gj-tooltip :content="row.title" :text-line="1">
            {{ row.title }}
          </gj-tooltip>
          <div class="hover-box">
            <editGoodTitle
              :row="row"
              v-if="$permission('listing:editListing') && $permission('listing:view')"
            />
          </div>
        </div>
      </template>
    </template>
    <template v-slot:marketId="{ row }">
      {{ row.marketId | optionText(marketOption) }}
    </template>
    <template v-slot:tags="{ row }">
      <gj-tag
        v-if="row.tags.includes('Ads')"
        :disabled="!$permission('listing:view')"
        class="gj-pointer"
        @click.native="handleAsinBoard(row)" type="plain" :color="{ color: '#1F6EEF', bdColor: '#4994FC', bgColor: '#EDF7FF' }">广告</gj-tag>
      <span class="coupon-tag" v-if="row.tags.includes('Coupon')">Coupon</span>
      <span class="outside-tag" v-if="row.tags.includes('Outside')">站外</span>
      <span v-if="!row.tags.includes('Ads') && !row.tags.includes('Coupon') && !row.tags.includes('Outside') ">-</span>
    </template>
    <template v-slot:asins="{ row }">
      <gj-icon
        iconfont="iconshuju1"
        v-if="$permission('listing:view')"
        @click.native="handleNavigateAsin(row)"
        class="analysis-icon"
      ></gj-icon>
    </template>
    <template v-slot:sku="{ row }">
      <template v-if="row.isVariant">
        <span>-</span>
      </template>
      <template v-else>
        <template v-if="isMeaningful(row.sku)">
          <gj-tooltip :text-line="1" :content="row.productName">
            {{ row.productName || '-' }}
          </gj-tooltip>
          <div class="flex">
            <gj-tooltip :text-line="1" :content="row.sku">
              {{ row.sku || '-' }}
            </gj-tooltip>
            <gj-copy-icon :content="row.sku"></gj-copy-icon>
          </div>
        </template>
        <template v-else>
          <gj-tooltip content="关联产品">
            <gj-link
              @click="relateProduct(row)"
              v-if="$permission('listing:view') && $permission('listing:linkProduct')"
            >
              <gj-icon iconfont="iconguanlian" style="font-size: 20px" id="skuicon"></gj-icon>
            </gj-link>
          </gj-tooltip>
        </template>
      </template>
    </template>
    <template v-slot:price="{ row }">
      <template>
        <div class="flex hover-class">
          <el-popover placement="bottom" trigger="hover">
            <template v-if="row.isVariant">
              <div>
                原价：{{ row.minYouPrice == row.maxYouPrice ? row.currencySymbol + row.minYouPrice : row.currencySymbol + row.minYouPrice + '-' + row.maxYouPrice }}
              </div>
              <div>
                优惠价：{{ row.minSalePrice == row.maxSalePrice ? row.currencySymbol + row.minSalePrice : (row.currencySymbol + row.minSalePrice + '-' + row.currencySymbol + row.maxSalePrice) }}
              </div>
            </template>
            <template v-else>
              <div>
                原价：{{ row.yourPrice ? `${row.currencySymbol}${row.yourPrice }` : '-' }}
              </div>
              <div>
                优惠价：{{ row.salePrice ? row.currencySymbol : '' }}{{ row.salePrice }}
              </div>
              <div>
                优惠时间：{{ row.saleStartDate }}-{{ row.saleEndDate }}
              </div>
            </template>
            <template slot="reference">
              <div v-if="row.isVariant">
                {{ row.minYouPrice == row.maxYouPrice ? row.currencySymbol + row.minYouPrice : row.currencySymbol + row.minYouPrice + '-' + row.currencySymbol + row.maxYouPrice }}
              </div>
              <div v-else>{{ row.price ? row.currencySymbol : '' }}{{ row.price }}</div>
            </template>
          </el-popover>
          <div
            class="hover-box gj-ml4"
            v-if="!row.isVariant && $permission('listing:adjustSalePrice') && $permission('listing:view')">
            <editGoodPrice :row="row" />
          </div>
        </div>
        <template v-if="row.isOffer && !row.isVariant">
          <gj-tooltip  v-if="row.isBuyBoxWinner" content="占据购物车">
            <i class="iconfont icongouwucheman colorYellow"></i>
          </gj-tooltip>
          <gj-tooltip  v-else content="丢失购物车">
            <i class="iconfont icongouwucheman color999"></i>
          </gj-tooltip>
        </template>
      </template>

    </template>
    <template v-slot:businessPrice="{ row }">
      <span class="hover-business-class">
        <span v-if="row.isVariant">
          <span v-if="row.minB2bPrice">
            {{ row.minB2bPrice === row.maxB2bPrice ? row.currencySymbol + row.minB2bPrice : row.currencySymbol + row.minB2bPrice  + '-' +  row.currencySymbol + row.maxB2bPrice }}
          </span>
          <span v-else> - </span>
        </span>
        <template v-else>
          <span>
            {{ row.businessPrice ? row.currencySymbol : '' }}
            {{ row.businessPrice }}
          </span>
          <span class="hover-business-box">
            <editB2bPrice
              :row="row"
              v-if="
                $permission('listing:adjustSalePrice') &&
                $permission('listing:view')
              "
            />
          </span>
        </template>
      </span>
    </template>
    <template v-slot:chargeNameList="{ row }">
      <gj-tooltip :text-line="2" :content="row.chargeNameList">
        {{row.chargeNameList | defaultShow}}
      </gj-tooltip>
      <span class="hover-business-box gj-ml5" v-if="!row.isVariant && $permission('listing:editDuty')">
        <editGoodsCharge :row="row" @editSucc="$gjNoticeQuery"/>
      </span>
    </template>

    <template v-slot:operationStatus="{ row }">
      {{row.operationStatus | defaultShow}}
      <span class="hover-business-box gj-ml5" v-if="!row.isVariant && $permission('listing:editOperationInfo')">
        <editGoodsOperation :row="row" @editSucc="$gjNoticeQuery"/>
      </span>
    </template>

    <template v-slot:fbaAvailableQuantity="{ row }">
      <template v-if="row.isVariant"> - </template>
      <template v-else>
        <gj-popover-panel title="FBA可售" :width="'180px'" :data="buildFBA(row)">
          {{ row.fulfillableQuantity }}
        </gj-popover-panel>
      </template>
    </template>

    <template v-slot:saleableTurnover="{ row }">
      <template v-if="row.isVariant"> - </template>
      <template v-else>
        <gj-popover-panel title="FBA可售周转" :width="'180px'" :data="buildFBACricle(row)">
          {{ row.saleableTurnover }}
        </gj-popover-panel>
      </template>
    </template>

    <template v-slot:mainCategoryRank="{ row }">
      <template v-if="!row.isVariant && row.listingSalesRank">
        <gj-tooltip :content="`# ${row.listingSalesRank.mainCategoryRank} in ${row.listingSalesRank.mainCategory}`" :text-line="2">
          <template v-if="row.listingSalesRank.mainCategoryLink">
            #<a class="bsr-a" :href="row.listingSalesRank.mainCategoryLink" target="_blank">{{
              row.listingSalesRank.mainCategoryRank
            }}</a>
          </template>
          <template v-else> #{{ row.listingSalesRank.mainCategoryRank }} </template>
          in {{ row.listingSalesRank.mainCategory }}
        </gj-tooltip>
      </template>
      <template v-else>-</template>
    </template>

    <template v-slot:mfnQuantity="{ row }">
      <template v-if="row.isVariant"> - </template>
      <template v-else>
        <span class="hover-mfnQuantity-class">
          {{ row.mfnQuantity || '-' }}
          <span class="hover-mfnQuantity-box">
            <editMfnQuantity
              :row="row"
              v-if="
                row.fulfillment === 'FBM' &&
                $permission('listing:editFulfillment') &&
                $permission('listing:view')
              "
            />
          </span>
        </span>
      </template>
    </template>

    <template v-slot:subCategoryRank="{ row }">
      <template v-if="!row.isVariant && row.listingSalesRank">
        <gj-tooltip :content="`# ${row.listingSalesRank.subCategoryRank} in ${row.listingSalesRank.subCategory}`" :text-line="2">
          <template v-if="row.listingSalesRank.subCategoryLink">
            #<a class="bsr-a" :href="row.listingSalesRank.subCategoryLink" target="_blank"
              >in{{ row.listingSalesRank.subCategoryRank }}</a
            >
          </template>
          <template v-else> #{{ row.listingSalesRank.subCategoryRank }} </template>
          in {{ row.listingSalesRank.subCategory }}
        </gj-tooltip>
      </template>
      <template v-else>-</template>
    </template>

    <template v-slot:star="{ row }">
      <template v-if="row.isVariant"> - </template>
      <template v-else>
        <div class="flex">
        <gj-rate disabled :value="row.star"></gj-rate>
        <div class="gj-ml4" style="white-space: nowrap">
          <span>{{ row.star }}</span>
          <span> ({{ row.reviewQuantity || '-' }})</span>
        </div>
      </div>
      </template>
    </template>
    <template v-slot:status="{ row }">
      <template v-if="row.isVariant">
        <span>-</span>
      </template>
      <template v-else>
        <gj-tag type="text" :color="row.statusColor">{{ row.status }}</gj-tag>
      </template>
    </template>
    <template v-slot:op="{ row }">
      <gj-button-group v-if="!row.isVariant" type="dropdown-op" ref="opgroup">
          <gj-button type="text" @click="edit(row)">编辑 </gj-button>
          <gj-button
            v-if="$permission('listing:caculateProfit')"
            type="text"
            @click="calculateProfit(row)"
            >试算利润
          </gj-button>
        <template #dropdown>
          <gj-dropdown-item
            v-if="$permission('listing:view')"
            @click="openLog(row.id)"
          >
            日志
          </gj-dropdown-item>
          <gj-dropdown-item
            @click="openChargeDistributionModal(row)"
            v-if="$permission('listing:editDuty')"
          >
            分配负责人
          </gj-dropdown-item>
          <gj-dropdown-item
            v-if="$permission('listing:optLogs')"
            @click="viewAsinOperationLog(row, 'Asin')"
          >
            ASIN运营日志
          </gj-dropdown-item>
          <template v-if="isMeaningful(row.sku)">
            <gj-dropdown-item
              @click="batchUnlinkProduct(row)"
              v-if="$permission('listing:linkProduct')"
              >解除关联</gj-dropdown-item
            >
          </template>
          <template v-else>
            <gj-dropdown-item
              @click="relateProduct(row)"
              v-if="$permission('listing:linkProduct')"
              >关联</gj-dropdown-item
            >
          </template>
        </template>
      </gj-button-group>
      <gj-button
        type="text"
        v-if="row.isVariant && isMeaningful(row.variationAsin) && $permission('listing:optLogs')"
        @click="viewAsinOperationLog(row, 'Variation')"
      >
        父ASIN运营日志
      </gj-button>
    </template>
  </gj-table>
</template>

<script>
  import {queryMixin, isMeaningfulMixin} from "@/minxins";
  import editGoodTitle from '../modal/edit-good-title';
  import editGoodPrice from '../modal/edit-good-price';
  import editB2bPrice from '../modal/edit-b2b-price';
  import editMfnQuantity from '../modal/edit-mfn-quantity';
  import editGoodsCharge from '../modal/edit-goods-charge';
  import editGoodsOperation from '../modal/edit-goods-operation';
  import AppEditListingModal from '../modal/edit-listing-modal';
  import ChargeDistributionModal from '../modal/charge-distribution-modal';
  import AppViewAsinOperationLogModal from '@/views/modules/sale/operation-log/modal/view/view-operation-log-modal';
  import AppListingHeader from '../modal/listing-header';
  import AppRelateProductModal from '@/views/layout/components/modal/relate-product-modal/relate-product-modal';
  import { batchUnlinkProduct } from '@/api/sale';
  import { mapGetters } from 'vuex';

  export default {
    name: "app-listing-table",
    mixins: [queryMixin, isMeaningfulMixin],
    props: {
      data: {
        type: Array,
      },
      customData: {
        type: Array,
        default: () => []
      },
      filter: {
        type: Object
      }
    },
    components: { editGoodTitle, editGoodPrice, editB2bPrice, editMfnQuantity, editGoodsCharge, editGoodsOperation },
    watch: {
      data: {
        handler() {
          if (this.data && this.data.length > 0) {
            const data = Object.assign(this.data);
            this.tableData = data;
            return;
          }
          this.tableData = [];
        },
        deep: true
      },
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption',
      })
    },
    data() {
      return {
        tableData: []
      }
    },
    methods: {
      buildFBA(row) {
        return [
          [{ label: '可售', value: row.fulfillableQuantity || '-'}],
          [
            { label: '预留', value: row.reservedQuantity || '-' },
            { label: '买家订单', value: row.reservedCustomerorders || '-' },
            { label: '转运中', value: row.reservedTransfers || '-' },
            { label: '处理中', value: row.reservedProcessing || '-' },
            { label: '入库中', value: row.receivingQuantity || '-' },
            { label: '已发货', value: row.shippedQuantity || '-' },
            { label: '计划入库', value: row.workingQuantity || '-' },
          ],
          [{ label: '不可售', value: row.unsellableQuantity || '-' }],
        ];
      },
      buildFBACricle(row) {
        return [
          [{ label: '可售周转', value: row.saleableTurnover || '-' }],
          [
            { label: '库龄', bold: true },
            { label: '0-30', value: row.invAge0To30Days || '-' },
            { label: '31-60', value: row.invAge31To60Days || '-' },
            { label: '61-90', value: row.invAge61To90Days || '-' },
            // { label: '0-90', value: row.invAge0To90Days || '-' },
            { label: '91-180', value: row.invAge91To180Days || '-' },
            { label: '181-270', value: row.invAge181To270Days || '-' },
            { label: '271-365', value: row.invAge271To365Days || '-' },
            { label: '365+', value: row.invAge365PlusDays || '-' },
          ],
        ];
      },
      // 试算利润跳转
      calculateProfit(row) {
        this.$router.push({
          path: `/sale/calculate-profit-modal/${row.id}`,
        });
      },
      /**
       * 调整asin分析
       * @param row
       */
      handleAsinBoard(row) {
        const params = {
          asin: row.asin,
          marketId: row.marketId
        };
        this.$router.push({
          path: '/ad/asin-analysis',
          query: params,
        });
      },
      /**
       * 跳转asin看板
       * @param row
       */
      handleNavigateAsin(row) {
        const params = {
          asinType: row.isVariant ? 'parent' : 'child',
          asinCode: row.asin,
          countryData: {
            countryIds: [row.countryCode], // 国家
            marketIds: [row.marketId], // 店铺
          },
          date: {
            type: 'DAY',
            value:
              this.filter.date.length && this.filter.date[0] && this.filter.date[1]
                ? this.filter.date
                : [],
          },
        };
        this.$router.push({
          path: '/statistics/asin-361-analysis',
          query: { params: JSON.stringify(params) },
        });
      },

      /**
       * 分配负责人弹窗
       * @param id
       */
      openChargeDistributionModal(row) {
        let ids = [row.id];
        const modal = this.$gjCreate(ChargeDistributionModal, {
          props: {
            ids,
          },
          on: {
            confirm: () => {
              this.$emit('updata-table');
              modal.$gjDestroy();
            },
          },
        });
      },

      viewAsinOperationLog(row, dimension) {
        this.$gjCreate(AppViewAsinOperationLogModal, {
          props: {
            header: () => ({
              component: AppListingHeader,
              style: {
                margin: '10px 0 0',
              },
              props: {
                id: row.id,
              },
            }),
            dimension,
            marketId: row.marketId,
            asin: row.asin,
            variationAsin: row.variationAsin,
            countryCode: row.countryCode,
          },
          on: {
            updated: () => {
              this.$emit('updata-table');
            },
          },
        });
      },

      relateProduct(item) {
        const vm = this;
        const modal = this.$gjCreate(AppRelateProductModal, {
          props: {
            id: item.id,
            mode: 'single',
            msku: item.msku,
          },
          on: {
            after() {
              vm.$emit('updata-table');
              modal.$gjDestroy();
            },
          },
        });
      },

      edit(row) {
        const vm = this;
        const modal = this.$gjCreate(AppEditListingModal, {
          props: {
            id: row.id,
          },
          on: {
            after() {
              vm.$emit('updata-table')
              modal.$gjDestroy();
            },
          },
        });
      },

      // 关联产品
      batchUnlinkProduct(row) {
        const vm = this;
        let ids = [row.id]
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: '您确定要解除该系列商品的关联关系吗?',
          },
          on: {
            cancel() {
              modal.$gjDestroy();
            },
            confirm() {
              modal.confirmLoading = true;
              batchUnlinkProduct({ ids })
                .then(() => {
                  vm.$gjMessage.success('操作成功');
                  vm.$emit('updata-table')
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading);
            },
          },
        });
      },
      // 日志
      openLog(id) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/operation/listing/${id}/logs`,
            columns: [
              { id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px' },
              { id: 'opUser', header: '操作用户', field: 'userName', minWidth: '100px' },
              {
                id: 'op',
                header: '操作分类',
                field: this.opTypeOption ? 'option:op' : 'op',
                options: this.opTypeOption,
                minWidth: '120px',
              },
              { id: 'opResult', header: '操作结果', field: 'opResult', overflowLine: 2, minWidth: '100px' },
              { id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px' },
            ],
          },
        });
      },
    },
  }

</script>

<style lang="scss" scoped>
.listing-table {
  /deep/ .tree-table__child--row {
    .vxe-cell--tree-node {
      padding-left: 5px !important;
    }
  }
  /deep/ .lazy-tree-child-row {
    background-color: #f7f8fa;
  }
  /deep/ .fixed-left--wrapper .lazy-tree-child-row {
    td:nth-child(1) {
      border-left: 3px solid #1F6EEF;
    }
  }
  .hover-box {
    opacity: 0;
    width: 0;
  }
  .vxe-body--row.row--hover .hover-box {
    opacity: 1;
    width: 12px;
  }
  .hover-business-box {
    opacity: 0;
    width: 0;
  }
  .hover-business-class {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    min-height: 30px;
  }
  .vxe-body--row.row--hover .hover-business-box{
    opacity: 1;
    width: 12px;
  }
  .hover-mfnQuantity-box {
    opacity: 0;
    width: 0;
  }
  .hover-mfnQuantity-class {
    width: 100%;
  }
  .vxe-body--row.row--hover .hover-mfnQuantity-box {
    opacity: 1;
    width: 100%;
  }
}
.coupon-tag {
  display: inline-block;
  color: #f6bb90;
  padding: 1px 5px;
  border: 1px solid #f6bb90;
  margin-right: 4px;
  border-radius: 5px;
  background: #FFF5ED;
}
.outside-tag {
  display: inline-block;
  padding: 1px 5px;
  color: #a973df;
  border: 1px solid #a973df;
  margin-right: 4px;
  margin-top: 2px;
  background: #F7F2FC;
  border-radius: 5px;
}
.bsr-a {
  color: #1f6eef;
  text-decoration-line: none;
}
.asin-msku_list {
  display: flex;
  a {
    color: #1f6eef;
    text-decoration-line: none;
  }
  .asin_list {
    flex: 10;
  }
  .msku_list {
    flex: 14;
    /deep/ .gj-tooltip {
      max-width: 86%;
    }
  }
}
.analysis-icon {
  font-size: 21px;
  color: #1f6eef;
  cursor: pointer;
}
.iconbangzhu {
  font-size: 13px;
  color: #606266;
}
.el-popover-my {
  text-align: center;
}
</style>